import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { useCallback } from "react";
import { logError } from "../logging";
export var useLocalNum = function() {
    var currencyFormatLocale = useLocalization().currencyFormatLocale;
    var localNumHook = useCallback(function(value, opts) {
        if (value === undefined) {
            return undefined;
        }
        try {
            return Intl.NumberFormat(currencyFormatLocale, opts).format(value);
        } catch (error) {
            logError("Error formatting number in useLocalNum. error: ".concat(error, ", currencyFormatLocale: ").concat(currencyFormatLocale, ", value: ").concat(value, ", opts: ").concat(opts));
            return undefined;
        }
    }, [
        currencyFormatLocale
    ]);
    return {
        localNum: localNumHook
    };
};
